import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref } from "vue";
import { ref, watch } from 'vue';
// 引入下面两项
import { ElConfigProvider } from 'element-plus';
// import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import zhCn from 'element-plus/es/locale/lang/zh-cn';
// import en from 'element-plus/lib/locale/lang/en'
import en from 'element-plus/es/locale/lang/en';
import { useStore } from 'vuex';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const store = useStore();
    // 定义 locale
    const locale = ref(zhCn);
    // 监听中英文切换 控制分页
    watch(() => store.getters.lang, () => {
      qiehuanZhEn(store.getters.lang);
    });
    function qiehuanZhEn(val) {
      if (val === 'en') {
        locale.value = en;
      } else {
        locale.value = zhCn;
      }
    }
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: locale.value
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component
          }) => [(_openBlock(), _createBlock(_KeepAlive, null, [_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 0
          })) : _createCommentVNode("", true)], 1024)), !_ctx.$route.meta.keepAlive ? (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: 0
          })) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});